export default function* numberIdGenerator(initial = 0) {
  let n = initial
  while (true) {
    yield n
    n += 1
  }
}
